<div class="css-adjuntar_archivo adjuntar_archivo">
  <label class="css-label_campo-1 label_campo" [for]="id">{{ etiqueta }}</label>
  <label class="css-label_adjuntar label_adjuntar"
    >Los formatos admitidos son PDF, DOC, DOCX, ODT, JPG, JPEG, PNG, TXT, XLSX,
    XLS y BPS</label
  >
  <label class="css-label_adjuntar label_adjuntar"
    >Tamaño máximo de archivos: 2 Mb.</label
  >
  <div class="css-agrupador_mensajes_file agrupador_mensajes_file">
    <input
      [id]="id"
      type="file"
      class="css-input_file_archivos input_file_archivos"
      multiple
      accept=".pdf,.doc,.docx,.odt,.jpg,.jpeg,.png,.txt,.bps,.xlsx,.xls"
      (change)="attachFiles($event)"
    />
    <div class="css-campo_archivos campo_archivos">
      <a class="css-a_texto_archivos a_texto_archivos"
        >Arrastre o seleccione archivos</a
      >
    </div>
    <div
      data-wcfid="listado_archivos_agregados"
      data-css-switch="lista_archivos"
      class="css-listado_archivos_agregados listado_archivos_agregados"
    >
      <!-- Instance of sub-component comp-archivo-agregado -->
      <app-archivo-agregado
        *ngFor="let archivo of attachments"
        [archivo]="archivo"
        (eliminar)="eliminarAdjunto($event)"
      ></app-archivo-agregado>
    </div>
    <div class="css-mensaje_ayuda_archivos mensaje_ayuda_archivos">
      <p class="css-texto_mensaje_ayuda_archivos texto_mensaje_ayuda_archivos">
        {{ mensaje_ayuda }}
      </p>
    </div>
    <div class="css-mensaje_error_archivos mensaje_error_archivos">
      <!-- Instance of sub-component comp-icon-mensaje-error -->
      <app-mensaje-error [mensaje_error]="mensaje_error"></app-mensaje-error>
    </div>
  </div>
</div>
